import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { successResponseSchema } from '@/api/schemas';

/**
 * Represents a request to delete a project.
 * This includes the key of the project to identify it and
 * a reason explaining why the project is being deleted.
 */
export interface HubspotResyncProject {
  projectId: string;
}

/**
 * Deletes an existing project.
 *
 * @param props contains a list of properties
 */
export async function hubSpotResyncProject(props: HubspotResyncProject) {
  const path = `/v1/crm/hubspot/resync`;
  const response = await api.post(path, {
    entityType: 'PROJECT',
    entityId: props.projectId,
  });

  return parseResponse(successResponseSchema, response.data, {
    schemaName: 'HubspotResyncProject',
    endpoint: path,
  });
}
